(() => {
  console.log("✅ PORTRAIT LIGHTBOX SCRIPT LOADED");

  // Inject minimal CSS (so it works even if lightbox.css isn't loaded)
  const STYLE_ID = "plb-inline-style";
  if (!document.getElementById(STYLE_ID)) {
    const st = document.createElement("style");
    st.id = STYLE_ID;
    st.textContent = `
      .portrait-lightbox{position:fixed; inset:0; z-index:999999; background:transparent;}
      .portrait-lightbox .plb-backdrop{position:absolute; inset:0; background:rgba(0,0,0,.75); backdrop-filter:blur(6px); -webkit-backdrop-filter:blur(6px);}
      .portrait-lightbox .plb-image{position:absolute; top:50%; left:50%; max-width:92%; max-height:88%; transform:translate(-50%,-50%) scale(1); object-fit:contain; cursor:zoom-in; user-select:none; -webkit-user-drag:none;}
      .portrait-lightbox .plb-close,.portrait-lightbox .plb-prev,.portrait-lightbox .plb-next{position:absolute; z-index:2; background:none; border:none; color:#fff; font-size:52px; line-height:1; padding:8px 12px; cursor:pointer;}
      .portrait-lightbox .plb-close{top:18px; right:22px;}
      .portrait-lightbox .plb-prev{left:18px; top:50%; transform:translateY(-50%);}
      .portrait-lightbox .plb-next{right:18px; top:50%; transform:translateY(-50%);}
    `;
    document.head.appendChild(st);
  }

  function getBiggestUrl(img) {
    const srcset = img.getAttribute("srcset");
    if (srcset) return srcset.split(",").pop().trim().split(" ")[0];
    return img.currentSrc || img.src;
  }

  function openLightbox(urls, startIndex) {
    let index = startIndex;

    // zoom state
    let scale = 1;
    let x = 0;
    let y = 0;
    let dragging = false;
    let startX = 0;
    let startY = 0;

    const overlay = document.createElement("div");
    overlay.className = "portrait-lightbox";
    overlay.innerHTML = `
      <div class="plb-backdrop"></div>
      <button class="plb-close" aria-label="Close">×</button>
      <button class="plb-prev" aria-label="Previous">‹</button>
      <button class="plb-next" aria-label="Next">›</button>
      <img class="plb-image" alt="" />
    `;
    document.body.appendChild(overlay);

    const backdrop = overlay.querySelector(".plb-backdrop");
    const imgEl = overlay.querySelector(".plb-image");
    const btnClose = overlay.querySelector(".plb-close");
    const btnPrev = overlay.querySelector(".plb-prev");
    const btnNext = overlay.querySelector(".plb-next");

    // ===== FORCE with !important (beats theme CSS) =====
overlay.style.setProperty("position", "fixed", "important");
overlay.style.setProperty("inset", "0", "important");
overlay.style.setProperty("width", "100vw", "important");
overlay.style.setProperty("height", "100vh", "important");
overlay.style.setProperty("z-index", "2147483647", "important");

// הכי חשוב: השחרה על ה-OVERLAY עצמו
overlay.style.setProperty("background-color", "rgba(0,0,0,0.75)", "important");
overlay.style.setProperty("backdrop-filter", "blur(6px)", "important");
overlay.style.setProperty("-webkit-backdrop-filter", "blur(6px)", "important");
overlay.style.setProperty("opacity", "1", "important");
overlay.style.setProperty("display", "block", "important");
overlay.style.setProperty("visibility", "visible", "important");
overlay.style.setProperty("pointer-events", "auto", "important");

// וגם על ה-backdrop (ליתר ביטחון, אפילו אם לא משפיע)
if (backdrop) {
  backdrop.style.setProperty("position", "fixed", "important");
  backdrop.style.setProperty("inset", "0", "important");
  backdrop.style.setProperty("width", "100vw", "important");
  backdrop.style.setProperty("height", "100vh", "important");
  backdrop.style.setProperty("background-color", "rgba(0,0,0,0.75)", "important");
  backdrop.style.setProperty("opacity", "1", "important");
  backdrop.style.setProperty("display", "block", "important");
  backdrop.style.setProperty("visibility", "visible", "important");
  backdrop.style.setProperty("pointer-events", "auto", "important");
}

// להחזיר כפתור יציאה גם אם הוסתר ב-CSS
btnClose.textContent = "×";
btnClose.style.setProperty("display", "flex", "important");
btnClose.style.setProperty("align-items", "center", "important");
btnClose.style.setProperty("justify-content", "center", "important");
btnClose.style.setProperty("visibility", "visible", "important");
btnClose.style.setProperty("opacity", "1", "important");
btnClose.style.setProperty("z-index", "2147483647", "important");
// ================================================


    function applyTransform() {
      imgEl.style.transform = `translate(calc(-50% + ${x}px), calc(-50% + ${y}px)) scale(${scale})`;
      imgEl.style.cursor = scale > 1 ? (dragging ? "grabbing" : "grab") : "zoom-in";
    }

    function resetZoom() {
      scale = 1;
      x = 0;
      y = 0;
      dragging = false;
      applyTransform();
    }

    function show(i) {
      index = (i + urls.length) % urls.length;
      imgEl.src = urls[index];
      resetZoom();
    }

    function close() {
      document.removeEventListener("keydown", onKey);
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
      overlay.remove();
    }

    // ✅ יציאה בלחיצה על הרקע
    backdrop.addEventListener("click", close);

    // גם לחיצה על אזור ריק (לא התמונה/כפתורים) יוצאת
    overlay.addEventListener("click", (e) => {
      if (e.target === backdrop) return;
      const clickedControls = e.target === imgEl || e.target === btnClose || e.target === btnPrev || e.target === btnNext;
      if (!clickedControls) close();
    });

    btnClose.addEventListener("click", close);
    btnPrev.addEventListener("click", () => show(index - 1));
    btnNext.addEventListener("click", () => show(index + 1));

    // zoom wheel
    imgEl.addEventListener("wheel", (e) => {
      e.preventDefault();
      const delta = e.deltaY > 0 ? -0.12 : 0.12;
      scale = Math.max(1, Math.min(4, scale + delta));
      if (scale === 1) { x = 0; y = 0; }
      applyTransform();
    }, { passive: false });

    // drag when zoomed
    imgEl.addEventListener("mousedown", (e) => {
      if (scale === 1) return;
      dragging = true;
      startX = e.clientX - x;
      startY = e.clientY - y;
      applyTransform();
    });

    function onMove(e) {
      if (!dragging) return;
      x = e.clientX - startX;
      y = e.clientY - startY;
      applyTransform();
    }
    function onUp() {
      dragging = false;
      applyTransform();
    }
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);

    // dblclick toggle zoom
    imgEl.addEventListener("dblclick", (e) => {
      e.preventDefault();
      if (scale === 1) scale = 2;
      else { scale = 1; x = 0; y = 0; }
      applyTransform();
    });

    function onKey(e) {
      if (e.key === "Escape") close();
      if (e.key === "ArrowLeft") show(index - 1);
      if (e.key === "ArrowRight") show(index + 1);
    }
    document.addEventListener("keydown", onKey);

    show(index);
  }

  function bind(root = document) {
    const imgs = Array.from(root.querySelectorAll('img[class*="ai-portrait-gallery__image-"]'))
      .filter(img => img.src && !img.src.startsWith("data:"));

    if (imgs.length < 2) return;

    const urls = imgs.map(getBiggestUrl);

    imgs.forEach((img, idx) => {
      if (img.dataset.lbBound === "1") return;
      img.dataset.lbBound = "1";
      img.style.cursor = "zoom-in";

      img.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        openLightbox(urls, idx);
      }, true);
    });

    console.log(`✅ Bound ${imgs.length} images`);
  }

  document.addEventListener("DOMContentLoaded", () => bind(document));
  document.addEventListener("shopify:section:load", (e) => bind(e.target));
})();